import React, { useEffect, useState } from "react";

const detectEnv = () => {
  const api = process.env.REACT_APP_API || "";
  if (api.includes("localhost") || api.includes("127.0.0.1")) return { label: "LOCAL", warn: false };
  // "dev." misses the real dev API host (dev-api.rootsfundme.ca), which made
  // the dev admin badge read PROD.
  if (api.includes("dev.") || api.includes("dev-") || api.includes("staging")) return { label: "DEV", warn: true };
  return { label: "PROD", warn: false };
};

const detectHost = () => {
  const api = process.env.REACT_APP_API || "";
  try {
    return new URL(api).host;
  } catch {
    return api.replace(/^https?:\/\//, "").replace(/\/.*$/, "") || "—";
  }
};

const formatUtc = (d) =>
  `${String(d.getUTCHours()).padStart(2, "0")}:${String(d.getUTCMinutes()).padStart(2, "0")}:${String(d.getUTCSeconds()).padStart(2, "0")} UTC`;

const SystemBar = () => {
  const [now, setNow] = useState(() => new Date());

  useEffect(() => {
    const id = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(id);
  }, []);

  const env = detectEnv();
  const host = detectHost();
  const admin = (() => {
    try {
      return JSON.parse(localStorage.getItem("admin"))?.data?.email || "";
    } catch {
      return "";
    }
  })();

  return (
    <div className="sysbar">
      <span className="sysbar__item">
        <span className={"sysbar__dot" + (env.warn ? " sysbar__dot--warn" : "")} />
        {env.label}
      </span>
      <span className="sysbar__sep sysbar__item--secondary">│</span>
      <span className="sysbar__item sysbar__item--secondary">API {host}</span>
      {admin && (
        <>
          <span className="sysbar__sep sysbar__item--secondary">│</span>
          <span className="sysbar__item sysbar__item--secondary">{admin}</span>
        </>
      )}
      <div className="sysbar__right">
        <span className="sysbar__item">{formatUtc(now)}</span>
      </div>
    </div>
  );
};

export default SystemBar;
